module.exports = __webpack_public_path__ + "static/media/qr-step2.2f5ca62e.svg";